import { Package, Plus } from 'lucide-react';
import { Button } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';

export function OtherAccessoriesPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-semibold text-foreground">Other Accessories</h1>
          <p className="text-sm text-foreground-muted">Custom accessories and miscellaneous items</p>
        </div>
        <Button size="sm" leftIcon={<Plus className="h-4 w-4" />}>
          Add Accessory
        </Button>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<Package className="h-10 w-10" />}
          title="No accessories yet"
          description="Track custom accessories and items that don't fit other categories."
          actionLabel="Add Accessory"
          onAction={() => {
            // TODO: Open add accessory modal
          }}
        />
      </div>
    </div>
  );
}
